import $axios from "../../api";
import FileSaver from "file-saver";

const state = {
  isLoading: false,
  createLoading: false,
  exportExcelLoading: false,
  exportPdfLoading: false,
  errors: "",
  isSuccess: false,
  list: [],
  data: {},
  groupList: [],
  page: 1,
};

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_LOADING_CREATE(state, payload) {
    state.createLoading = payload;
  },

  SET_LOADING_EXPORT_EXCEL(state, payload) {
    state.exportExcelLoading = payload;
  },
  SET_LOADING_EXPORT_PDF(state, payload) {
    state.exportPdfLoading = payload;
  },
  SET_ERRORS(state, payload) {
    state.errors = payload;
  },
  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_EXTENSION_LIST(state, payload) {
    state.list = payload;
  },
  SET_EXTENSION_DATA(state, payload) {
    state.data = payload;
  },
  SET_CREATE_LOAD(state, payload) {
    state.createLoading = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  ASSIGN_GROUP_LIST(state, payload) {
    state.groupList = payload;
  },
};

const actions = {
  /**
   * ==========================
   * GET LIST
   * ==========================
   */
  getList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);

    return new Promise((resolve, reject) => {
      $axios
        .get(
          `hr/phone-extension/list?page=${state.page}&view=${rootState.Main.view}${payload ? payload : ""
          }`
        )
        .then((response) => {
          commit("SET_EXTENSION_LIST", response.data.data);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },

  /**
   * ==========================
   * GET DETAIL (optional kalau mau edit modal)
   * ==========================
   */
  getData({ commit, dispatch }, payload) {
    commit("SET_LOADING", true);

    return new Promise((resolve, reject) => {
      $axios
        .get(`hr/phone-extension/view?id=${payload}`)
        .then((response) => {
          commit("SET_EXTENSION_DATA", response.data.data);
          commit("SET_LOADING", false);
          resolve(response);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },

  /**
   * ==========================
   * CREATE
   * ==========================
   */
  create({ commit, dispatch }, payload) {
    commit("SET_SUCCESS", false);
    commit("SET_CREATE_LOAD", true);

    return new Promise((resolve, reject) => {
      $axios
        .post(`hr/phone-extension/create`, payload)
        .then((response) => {
          commit("SET_CREATE_LOAD", false);
          commit("SET_SUCCESS", true);
          dispatch(
            "Main/globalSuccessSweetAlert",
            response.data.message,
            { root: true }
          );
          resolve(response);
        })
        .catch((error) => {
          commit("SET_ERRORS", error.response.data.errors);
          commit("SET_CREATE_LOAD", false);
          commit("SET_SUCCESS", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },

  /**
   * ==========================
   * UPDATE
   * ==========================
   */
  update({ commit, dispatch }, payload) {
    commit("SET_SUCCESS", false);
    commit("SET_CREATE_LOAD", true);

    return new Promise((resolve, reject) => {
      $axios
        .put(`hr/phone-extension/update`, payload)
        .then((response) => {
          commit("SET_CREATE_LOAD", false);
          commit("SET_SUCCESS", true);
          dispatch(
            "Main/globalSuccessSweetAlert",
            response.data.message,
            { root: true }
          );
          resolve(response);
        })
        .catch((error) => {
          commit("SET_ERRORS", error.response.data.errors);
          commit("SET_CREATE_LOAD", false);
          commit("SET_SUCCESS", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },

  /**
   * ==========================
   * SHOW / HIDE
   * ==========================
   */
  showhide({ commit, dispatch }, payload) {
    commit("SET_SUCCESS", false);
    commit("SET_CREATE_LOAD", true);
    return new Promise((resolve, reject) => {
      $axios
        .post(`hr/phone-extension/showhide`, payload)
        .then((response) => {
          commit("SET_SUCCESS", true);
          dispatch(
            "Main/globalSuccessSweetAlert",
            response.data.message,
            { root: true }
          );
          commit("SET_CREATE_LOAD", false);
          resolve(response);
        })
        .catch((error) => {
          commit("SET_SUCCESS", false);
          commit("SET_CREATE_LOAD", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  /**
   * ==========================
   * EXPORT EXCEL
   * ==========================
   */
  exportExcel({ commit, dispatch }, payload) {
    commit("SET_LOADING_EXPORT_EXCEL", true);
    return new Promise((resolve, reject) => {
      $axios({
        url: `hr/phone-extension/export-excel${payload ? payload : ""}`,
        method: "GET",
        responseType: "blob"
      })
        .then((response) => {

          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");

          link.href = url;
          link.setAttribute("download", "PhoneExtensions.xlsx");

          document.body.appendChild(link);
          link.click();
          link.remove();

          commit("SET_LOADING_EXPORT_EXCEL", false);
          resolve(response);
        })
        .catch((error) => {
          commit("SET_LOADING_EXPORT_EXCEL", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  /**
  * ==========================
  * EXPORT PDF
  * ==========================
  */
  exportPdfBC({ commit, dispatch }, query) {

    commit("SET_LOADING_EXPORT_PDF", true);
    const url = `hr/phone-extension/export-pdf?type=pdf${query || ""}`;

    return new Promise((resolve, reject) => {

      $axios({
        url: url,
        method: "GET",
        responseType: "blob"
      })
        .then((response) => {

          const blob = new Blob([response.data], { type: "application/pdf" });
          const downloadUrl = window.URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = downloadUrl;
          link.setAttribute("download", "PhoneExtensions.pdf");

          document.body.appendChild(link);
          link.click();

          link.remove();
          window.URL.revokeObjectURL(downloadUrl);

          commit("SET_LOADING_EXPORT_PDF", false);
          resolve(response);

        })
        .catch((error) => {

          dispatch("Main/globalSweetAlert", error.response, { root: true });

          commit("SET_LOADING_EXPORT_PDF", false);
          reject(error);

        });

    });
  },
  exportPdf({ commit, state, dispatch }, payload) {
    commit("SET_LOADING_EXPORT_PDF", true);

    return new Promise((resolve, reject) => {
      $axios
        .get(
          `hr/phone-extension/export-pdf?type=pdf${payload ? payload : ""}`,
          { responseType: "blob" }
        )
        .then((response) => {
          FileSaver.saveAs(
            response.data,
            `PhoneExtensions.pdf`
          );

          commit("SET_LOADING_EXPORT_PDF", false);
          resolve(response);
        })
        .catch((error) => {
          commit("SET_LOADING_EXPORT_PDF", false);
          dispatch("Main/globalSweetAlert", error.response, { root: true });
          reject(error);
        });
    });
  },
  /**
   * ==========================
   * SELECT GROUP
   * ==========================
   */
  selectGroup({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return new Promise((resolve, reject) => {
      $axios
        .get(`hr/phone-extension/group?find=${payload ? payload : ""}`)
        .then((res) => {
          commit("ASSIGN_GROUP_LIST", res.data.data);
          commit("SET_LOADING", false);
        })
        .catch((error) => {
          commit("SET_LOADING", false);
          dispatch("Main/globalSweetAlert", error.response, {
            root: true,
          });
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};